( function ($) {
    $(document).ready(function () {
        var wraps = $('.children_section');
        wraps.each(function () {
            var wrap = $(this);
            viewChildDetails(wrap.find('.item_wrap a.title.show_inline_preview'));
            viewChildDetails(wrap.find('.item_wrap a.thumb.show_inline_preview'));
            viewChildDetails(wrap.find('.item_wrap .read_more.show_inline_preview a'));
        })
    });

    function viewChildDetails(link) {

        link.click(function () {
            var overlayToOpen = '#' + $(this).closest('.item_wrap').attr('data-link');
            var contentToShow = $(overlayToOpen).html();

            $('body').append(contentToShow);
            $('html').addClass('no_scroll');

            var close = $('.mega_details_wrapper .close');
            close.click(function () {
                $(this).closest('.mega_details_wrapper').remove();
                $('html').removeClass('no_scroll');
            });

            var additional =  $('.mega_details_wrapper .btn.additional');
            additional.click(function () {
                var button = $(this).find('a');
                var data = button.data('src');
                if (!data) {
                    return;
                }
                var html = $(data).text();
                $.fancybox.open(html, {
                    'beforeShow' : function (){
                        prevScroll = $(document).scrollTop();
                        $(document).scrollTop(0);
                    },
                    'afterShow': function () {
                        if (typeof renderRecaptcha !== 'undefined') {
                            renderRecaptcha();
                        }
                        if (typeof gformInitDatepicker !== 'undefined') {
                            isFixed = false;
                            jQuery( '.datepicker' ).eq(0).parents().each( function() {
                                isFixed |= jQuery( this ).css( "position" ) === "fixed";
                                return !isFixed;
                            } );
                            setTimeout(gformInitDatepicker, 101 );
                        }

                    },
                    'beforeClose' : function (){
                        $(document).scrollTop(prevScroll);
                    },
                    arrows: false,
                    infobar: false
                });
                $(this).closest('.mega_details_wrapper').fadeOut(1000);
                $('html').removeClass('no_scroll');
            })

        });
    }
}(jQuery) );
